import React from 'react';
import './TopPages.css';

const TopPages = ({ pages, isLoading }) => {
  const truncatePath = (path, maxLength = 30) => {
    if (path.length <= maxLength) return path;
    return path.substring(0, maxLength) + '...';
  };

  if (isLoading) {
    return (
      <div className="ga-pages-card">
        <div className="ga-pages-header">
          <div className="ga-pages-title">Top pages</div>
          <div className="ga-skeleton" style={{ width: '40px', height: '20px', borderRadius: '10px' }}></div>
        </div>
        
        <table className="ga-pages-table">
          <thead className="ga-pages-thead">
            <tr>
              <th>Page</th>
              <th>Views</th>
              <th>Users</th>
            </tr>
          </thead>
          <tbody className="ga-pages-tbody">
            {[1, 2, 3, 4, 5].map(i => (
              <tr key={i}>
                <td>
                  <div className="ga-skeleton" style={{ width: '180px', height: '14px' }}></div>
                </td>
                <td>
                  <div className="ga-skeleton" style={{ width: '40px', height: '14px' }}></div>
                </td>
                <td>
                  <div className="ga-skeleton" style={{ width: '30px', height: '14px' }}></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="ga-pages-card">
      <div className="ga-pages-header">
        <div className="ga-pages-title">Top pages</div>
        <div className="ga-pages-count">{pages.length}</div>
      </div>
      
      <table className="ga-pages-table">
        <thead className="ga-pages-thead">
          <tr>
            <th>Page</th>
            <th>Views</th>
            <th>Users</th>
          </tr>
        </thead>
        <tbody className="ga-pages-tbody">
          {pages.map((page, index) => (
            <tr key={index}>
              <td>
                <div className="ga-page-path" title={page.path}>
                  {truncatePath(page.path)}
                </div>
              </td>
              <td>
                <div className="ga-page-views">
                  {page.views.toLocaleString()}
                </div>
              </td>
              <td>
                <div className="ga-page-users">
                  {page.users.toLocaleString()}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {pages.length === 0 && !isLoading && (
        <div style={{ textAlign: 'center', color: 'var(--ga-muted)', fontSize: '0.875rem', padding: '2rem 0' }}>
          No page data available
        </div>
      )}
    </div>
  );
};

export default TopPages;